import ProfiloView from "./components/ProfiloView.vue";
import ProfiloEdit from "./components/ProfiloEdit.vue";
export default {
  ProfiloView,
  ProfiloEdit,
};